import {
  Button, Dropdown, Table, Tooltip,
} from "antd";
import {
  MoreOutlined, EditOutlined, DeleteOutlined,
} from "@ant-design/icons";
import React from "react";
import moment from "moment";
import RuleStatusTag from "./RuleStatusTag";
import { buildTestMenuItem } from "../qcRuleTableMenuItems";

export default function QcRulesTable({
  dataSource,
  loading,
  onRowClick,
  onEdit,
  onDelete,
  onTest,
  pagination = false,
}) {
  return (
    <Table
      rowKey={(rule) => rule.rule_id}
      dataSource={dataSource}
      pagination={pagination}
      bordered
      rowHoverable
      loading={loading}
      className="QcRules_Table"
      onRow={(data) => ({
        onClick: () => onRowClick(data),
      })}
    >
      <Table.Column
        title="Type"
        dataIndex="rule_type"
        key="rule_type"
      />
      <Table.Column
        title="Description"
        dataIndex="rule_description"
        key="rule_description"
        render={(value) => <>{value || "-"}</>}
      />
      <Table.Column
        title="Status"
        dataIndex="is_active"
        key="is_active"
        render={(value) => <RuleStatusTag result={value} />}
      />
      <Table.Column
        title="Created By"
        dataIndex="created_by"
        key="created_by"
        render={(value, data) => (
          <Tooltip title={data?.created_at ? moment(data.created_at).format("MM/DD/YYYY, h:mm:ss a") : ""}>
            <>{value}</>
          </Tooltip>
        )}
      />
      <Table.Column
        title="Updated By"
        dataIndex="updated_by"
        key="updated_by"
        render={(value, data) => (
          <Tooltip title={data?.updated_at ? moment(data.updated_at).format("MM/DD/YYYY, h:mm:ss a") : ""}>
            <>{value}</>
          </Tooltip>
        )}
      />
      <Table.Column
        title="Action"
        render={(_, record) => (
          <Dropdown
            menu={{
              items: [
                {
                  key: "edit",
                  label: "Edit",
                  icon: <EditOutlined />,
                  onClick: (e) => {
                    e.domEvent.preventDefault();
                    e.domEvent.stopPropagation();
                    onEdit(record);
                  },
                },
                buildTestMenuItem(record, onTest),
                {
                  key: "delete",
                  label: "Delete",
                  icon: <DeleteOutlined />,
                  onClick: (e) => {
                    e.domEvent.preventDefault();
                    e.domEvent.stopPropagation();
                    onDelete(record);
                  },
                },
              ],
            }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Button
              type="text"
              size="medium"
              icon={<MoreOutlined />}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </Dropdown>
        )}
      />
    </Table>
  );
}
